import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type DAOExpanderRegistryContractFunctions1 =
  | []
  | [DAOExpanderRegistryContractFunctions]
  | [DAOExpanderRegistryContractFunctions, DAOExpanderRegistryContractEvents];
export type SWEvent = {
  event: DAOExpanderRegistryContractEventType;
  args: any;
}[];

export interface DAOExpanderRegistryContractFunctions {
  autIDAddr: (overrides?: CallOverrides) => Promise<string>;
  daoExpanders: (argument_0: number, overrides?: CallOverrides) => Promise<string>;
  daoTypes: (overrides?: CallOverrides) => Promise<string>;
  deployDAOExpander: (
    daoType: number,
    daoAddr: string,
    market: number,
    metadata: string,
    commitment: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderRegistryContractEvents>}>;
  getDAOExpanders: (overrides?: CallOverrides) => Promise<string[]>;
  getDAOExpandersByDeployer: (deployer: string, overrides?: CallOverrides) => Promise<string[]>;
}
export interface DAOExpanderRegistryContractEvents {
  events: SWEvent;
}

export enum DAOExpanderRegistryContractEventType {
  DAOExpanderDeployed = "DAOExpanderDeployed"
}
